import { type FC, Fragment } from "react";

import { type DraftCitationFragment } from "@app_schema";

import { CitationChip } from "@styled/citation_chip";

import { useOpenPage } from "./use_open_page";

// A citation as its source and a page chip, as the case Summary cites the
// Records: the chip opens the first page beside the chat. As written when no
// page opens (the intake, a dictation, or a page no record has).
export const CitedPages: FC<{ citation: DraftCitationFragment }> = ({
  citation,
}) => {
  const openPage = useOpenPage();
  const { documentId, pages } = citation;
  const [page] = pages;
  if (!openPage || !documentId || page === undefined) return citation.text;

  return (
    <>
      {citation.source}
      <CitationChip
        pages={pages}
        onPress={() => openPage({ documentId, page })}
      />
    </>
  );
};

// Several, apart with " · ".
export const CitedPagesList: FC<{
  citations: readonly DraftCitationFragment[];
}> = ({ citations }) =>
  citations.map((citation, index) => (
    <Fragment key={citation.text}>
      {index > 0 && " · "}
      <CitedPages citation={citation} />
    </Fragment>
  ));
